import { PLANS } from '../lib/plans';

export default function PlanBadge({ planKey, size = 'md' }) {
  const p = PLANS[planKey || 'pyme'];
  if (!p) return null;
  const cls = size === 'sm' ? 'text-[9.5px] px-1.5 py-0.5' : 'text-[10px] px-2 py-0.5';
  return (
    <span
      className={`${cls} uppercase tracking-wider font-semibold border rounded-full`}
      style={{ color: p.color, borderColor: `${p.color}66`, backgroundColor: `${p.color}12` }}
      data-testid={`plan-badge-${p.key}`}
    >
      Plan {p.name}
    </span>
  );
}
